var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 176,
    viewBox: "0 0 177 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#googleCalendar_svg__filter0_d_3871_29541)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.211,
    y: 26,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F6F8FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.766 66.555h38.889v38.889h-38.89v-38.89z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.1 67.111v37.778H67.322V67.111H105.1zM106.211 66h-40v40h40V66z",
    fill: "#2C5BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.766 66.555h38.889v5.555h-38.89v-5.555z",
    fill: "#D8E0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.1 67.111v4.445H67.322V67.11H105.1zM106.211 66h-40v6.667h40V66z",
    fill: "#2C5BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.431 79.334h2.223v2.222H78.43v-2.222zm8.89 0h2.222v2.222H87.32v-2.222zm4.444 0h2.222v2.222h-2.222v-2.222zm4.444 0h2.222v2.222H96.21v-2.222zm-22.222 4.444h2.222v2.223h-2.222v-2.223zm4.444 0h2.223v2.223H78.43v-2.223zm8.89 0h2.222v2.223H87.32v-2.223zm4.444 0h2.222v2.223h-2.222v-2.223zm4.444 0h2.222v2.223H96.21v-2.223zm-22.222 8.89h2.222v2.221h-2.222v-2.222zm4.444 0h2.223v2.221H78.43v-2.222zm8.89 0h2.222v2.221H87.32v-2.222zm-4.445-13.334h2.222v2.222h-2.222v-2.222zm0 4.444h2.222v2.223h-2.222v-2.223zm-8.889 4.445h2.222v2.222h-2.222v-2.222zm4.444 0h2.223v2.222H78.43v-2.222zm8.89 0h2.222v2.222H87.32v-2.222zm4.444 0h2.222v2.222h-2.222v-2.222zm4.444 0h2.222v2.222H96.21v-2.222zm-13.333 0h2.222v2.222h-2.222v-2.222zm0 4.444h2.222v2.222h-2.222v-2.222zm8.889 0h2.222v2.222h-2.222v-2.222zm-24.445 8.889h37.778v3.334H67.32v-3.334z",
    fill: "#D8E0FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "googleCalendar_svg__filter0_d_3871_29541",
    x: 0.211,
    y: 0,
    width: 176,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.155 0 0 0 0 0.231506 0 0 0 0 0.516667 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3871_29541"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3871_29541",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "media/photographerOnboarding/googleCalendar-dc8f595a.svg";
export { SvgGoogleCalendar as ReactComponent };